export const DECKING_TYPE_ORDER: string[] = [
	'Eva-Last Pioneer',
	'Eva-Last Apex Plus',
	'Eva-Last Infinity',
	'Timbertech Vintage',
	'Timbertech Landmark',
	'Timbertech Harvest+',
	'Timbertech Harvest',
	'Timbertech Legacy',
	'Timbertech Reserve',
	'Timbertech Terrain+',
	'Timbertech Terrain',
	'Timbertech Prime Plus',
	'Trex Signature',
	'Trex Transcend Lineage',
	'Trex Transcend',
	'Trex Select',
	'Trex Enhance Naturals',
	'Trex Enhance Basics',
	'2x6 Pressure Treated',
];
